<template>
  <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
    <v-card>
      <v-app-bar app floating flat color="transparent">
        <v-btn icon dark @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-app-bar>
      <camera-app
        ref="camera"
        class="ma-0 pa-0"
        :instruction="instruction"
        :snackbarTitle="snackbarTitle"
        :overlayAsset="asset"
        v-on:image-taken="imageTaken"
        v-on:camera-error="cameraError"
      />
    </v-card>
  </v-dialog>
</template>

<script lang="ts">
import CameraApp from "@/components/camera/CameraApp.vue";
import { AssetEnum } from "@/lib/AssetRepository";
import { IReportInstructionData } from "@/lib/interfaces/Report/IReportInstructionData";
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  components: {
    CameraApp
  }
})
export default class CameraDialog extends Vue {
  private dialog = false;

  @Prop()
  private instruction!: IReportInstructionData;

  @Prop()
  private snackbarTitle!: string;

  @Prop()
  private asset!: AssetEnum;

  @Prop({ default: true })
  closeOnPhotoTaken!: boolean;

  @Prop()
  private handleUploadCb!: (file: File) => Promise<void>;

  @Prop()
  private handleDeleteCb!: (file: File) => Promise<boolean>;

  async mounted() {
    this.dialog = true;
    await (this.$refs.camera as CameraApp).startRecording();
  }

  public async close() {
    this.$emit("close-camera-dialog");
    await (this.$refs.camera as CameraApp).stopRecording();
  }

  /**
   * Intercept the handleUploadCb event and pass it to the parent.
   * After that close the dialog.
   */
  public async imageTaken(file: File) {
    this.handleUploadCb(file);
    if (this.closeOnPhotoTaken) {
      this.close();
    }
  }

  /**
   * Handle Camera error event
   */
  public cameraError() {
    this.close();
  }
}
</script>
